export default "__VITE_PUBLIC_ASSET__bfa15658__"